// extracted by mini-css-extract-plugin
export default {"row":"styles_row__5Nm0c","cell":"styles_cell__v2kQR","tableContainer":"styles_tableContainer__dSS-s","buttonMenu":"styles_buttonMenu__SMGsl"};